/**
 * Code tag của thị trường VN, còn lại cho module tag cũ (`src/components/mocules/*`) và
 * logic sort ở `src/context/Product/context.js`.
 *
 * Module tag TH không dùng bảng này: allow-list và thứ tự lấy từ CMS
 * (xem `src/utils/TagUtils.js`, `docs/product-tag-display-spec.md`).
 */
export const ENUM_TAG_CODES = {
  HANG_DIEM: 'Y7GB',
  HANG_HANG: '2ABC',
  HOADONNHANH: 'HOADONNHANH',
  KHUYENMAI: 'DEAL',
};

export default {
  ENUM_TAG_CODES,
};
